import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-reportes-index',
  templateUrl: './reportes-index.component.html',
  styleUrls: ['./reportes-index.component.css']
})
export class ReportesIndexComponent {

  TipoUsuario = TipoUsuario;

  constructor(private authService: AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

}
